export type { WorkspaceStateSettings } from '../workspace.state/index.ts';
export {
  type CheckDepsStatusOptions,
  type CheckDepsStatusResult,
  checkDepsStatus,
} from './checkDepsStatus.ts';
